<template>
  <div class="w-full min-table-width mt-4">
    <div class="w-full flex items-center justify-center" v-if="!filteredList.length">
      <span class="text-grey-darker">No results found.</span>
    </div>
    <table v-else class="mx-auto border border-b-0 rounded-b-none border-grey-light rounded px-8">
      <thead>
        <tr>
          <th class="cursor-pointer" v-for="title in columnHeads" @click="emitSortBy(title)" :key="title">
            <h6 v-if="title === 'stage'" class="flex items-center text-grey-darker text-xs uppercase text-center whitespace-pre h-6">
              <span class="flex">
                <span class="flex items-center justify-center mr-8">stage <span v-html="defineArrow(title)" /></span>
                <span v-tooltip="toolTipContent" class="h-6 w-6 border border-grey-light rounded-full flex items-center justify-center leading-none">?</span>
              </span>
            </h6>
            <h6 v-else class="flex items-center text-grey-darker text-xs uppercase text-center whitespace-pre h-6">{{title}} <span v-html="defineArrow(title)" /></h6>
          </th>
        </tr>
      </thead>
      <tbody class="mt-6">
        <tr v-for="data in filteredList" @click="!isBroker && rowClicked(data)"  class="cursor-pointer border_bottom transition" :key="data.metaData.id">
          <td v-for="(value, key, index) in removeMeta(data)" :key="`tbody-${index}`">
            <component
              v-if="value.component"
              :is="value.component"
              v-bind="value.props"
              @componentEvent="componentEvent"
            ></component>
            <span class="table-base-content text-grey-darker mt-2" v-else>{{value}}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      @changePerPage="changePerPage"
      @changePage="changePage"
      :per-page="perPage"
      :current-page="currentPage"
      :total-items="rowData.length"
    />
  </div>
</template>

<script>

import _ from 'lodash'
import * as Items from './TableComponents';

export default {
  name: 'Table',
  components: {
    ...Items,
  },
  props: {
    columnHeads: {
      type: Array,
      default () {
        return []
      },
    },
    toolTipContent: {
      type: Object,
    },
    rowData: {
      type: Array,
      default () {
        return []
      },
    },
    searchCriteria: {
      type: String,
      default () {
        return ''
      },
    },
    isBroker: {
      type: Boolean,
      default () {
        return false
      },
    },
    searchValue: {
      type: [String, Array],
      default () {
        return ''
      },
    },
    type: {
      type: String,
      default () {
        return ''
      },
    },
  },
  data () {
    return {
      sortKey: '',
      perPage: 10,
      currentPage: 1,
      sortCriteria: [],
    }
  },
  methods: {
    changePerPage(pages) {
      this.perPage = pages;
    },
    changePage(page) {
      this.currentPage = page;
    },
    rowClicked(data) {
      this.$emit('rowClick', data);
    },
    removeMeta({ metaData, ...rest }) {
      return {...rest};
    },
    // bubbling up this event to the parent
    componentEvent(data) {
      this.$emit('actionCell', data);
    },
    emitSortBy(type) {
      this.sortTableBy(type);
      this.$emit('sortBy', this.sortCriteria)
    },
    sortTableBy(type) {
      const isSortTypePresent = this.sortCriteria.map((item) => item.type).includes(type)
      if (!isSortTypePresent) {
        this.sortCriteria.push({ type, asec: true })
      } else {
        const idx = this.sortCriteria.map((item) => item.type).indexOf(type);
        this.sortCriteria[idx].asec = !this.sortCriteria[idx].asec;
      }
    },
    defineArrow(title) {
      const dataObj = _.find(this.sortCriteria, (item) => item.type === title);
      if (dataObj) {
        if (dataObj.asec) {
          return '&#x2191;';
        } else {
          return '&#x2193;';
        }
      }
    },
  },
  computed: {
    filteredList () {
      const segmentedDataFunc = (rawData) => _.slice(rawData, (this.currentPage - 1) * this.perPage, (((this.currentPage - 1) * this.perPage) + this.perPage))
      const segmentedData = segmentedDataFunc(this.rowData);

      const isMatched = (searchItem, searchValue) => searchItem.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;

      if (this.searchValue) {
        const filteredData = _.filter(this.rowData, (dataSet) => {
          const searchItem = _.get(dataSet, this.searchCriteria);
          if (Array.isArray(this.searchValue)) {
            const data = this.searchValue.filter((val) => {
              if (!searchItem || !val) return false;
              return isMatched(searchItem, val)
            })
            return data.length > 0;
          } else {
            if (!searchItem || !this.searchValue) return false;
            return isMatched(searchItem, this.searchValue);
          }
        })
        return segmentedDataFunc(filteredData);
      }
      return segmentedData;
    },
  },
}
</script>
<style scoped>
.min-table-width {
  min-width: 1132px;
}
tr {
  height: 55px;
}
tbody tr:hover {
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.21);
  border-bottom: 2px solid grey;
}
/* tbody tr {
  border-bottom: 2px solid grey;
} */
td {
  min-width: 160px;
  max-width: 290px;
}
.table-base-content{
  max-width: 280px;
  overflow:hidden;
  display:inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.border_bottom td {
  border-bottom:1px solid #dae1e7;
}

.transition {
  transition: all linear 0.4s;
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue